/**
  * @class meleCalendarDatetime
  * @description
  *
  * # Purpose
  * Implements `<mele-calendar-datetime>` custom web element for showing date/time for player
  */

import meleElement from 'meleElement'

const UNITS = ['year', 'month', 'day', 'hour', 'minute', 'second']

const PROPERTIES = _.extend({}, {
  readonly: { type: 'boolean', description: 'if the element is read only' },
  label: { description: 'optional label for the element', type: 'string' },
  value: { type: 'string', description: 'current selected time in epoch seconds' },
  selected: { type: 'string', default: 'day', enum: ['year', 'month', 'day', 'hour', 'minute', 'second'], description: 'currently selected unit' },
  lastunit: { type: 'string', default: 'second', enum: ['year', 'month', 'day', 'hour', 'minute', 'second'], description: 'last displayed and selectable unit' },
  eventSelected: { type: 'function', description: 'Called when user clicks on any unit element' },
  calendar: { type: 'element', description: 'mele-calendar-player to be updated', noattribute: true },
  snapshots: { type: 'element', description: 'mele-calendar-snapshots to be updated', noattribute: true },
}, meleElement._properties)

export default class meleCalendarDatetime extends meleElement {
  init() {
    [this.elLabel, this.elValue] = this.appendChildren([
      { tag: 'mele-text' },
      { tag: 'value' },
    ]);
    [
      this.elYear, this.tmp,
      this.elMonth, this.tmp,
      this.elDay, this.tmp,
      this.elHour, this.tmp,
      this.elMinute, this.tmp,
      this.elSecond, this.tmp,
    ] = this.elValue.appendChildren([
      { tag: 'div', class: 'year' },
      { tag: 'span', class: 'month', html: '-' },
      { tag: 'div', class: 'month' },
      { tag: 'span', class: 'day', html: '-' },
      { tag: 'div', class: 'day' },
      { tag: 'span', class: 'hour', html: '&nbsp;' },
      { tag: 'div', class: 'hour' },
      { tag: 'span', class: 'minute', html: ':' },
      { tag: 'div', class: 'minute' },
      { tag: 'span', class: 'second', html: ':' },
      { tag: 'div', class: 'second' },
    ])
    super.init()
    this.selectedChanged(this.selected, '')
  } // init

  onclick(e) {
    if(this.readonly) return
    const value = e?.target?.className
    if(/^(year|month|day|hour|minute|second)$/.test(value)) this.setProperty('selected', value, true)
  } // onclick

  labelChanged(value) {
    this.elLabel.label = value
  } // labelChanged

  selectedChanged(value, old, context_user_interaction) {
    const interactive = !!context_user_interaction
    value = value || ''
    for(const el of [...this.elValue.children]) {
      if(el.className==value) el.setAttribute('selected', '')
      else el.removeAttribute('selected')
    }
    if(value) this.updateLinkedElements()
    this.eventSelected(this, value||'', old, interactive)
  } // unitChanged

  eventSelected(self, selected, old, interactive) {
  } // eventSelected

  calendarChanged() {
    this.updateLinkedElements()
  } // calendarChanged

  valueChanged() {
    const dt = new Date(this.value*1000)
    this.elYear.innerHTML = dt.getFullYear()
    this.elMonth.innerHTML = _.two(dt.getMonth()+1)
    this.elDay.innerHTML = _.two(dt.getDate())
    this.elHour.innerHTML = _.two(dt.getHours())
    this.elMinute.innerHTML = _.two(dt.getMinutes())
    this.elSecond.innerHTML = _.two(dt.getSeconds())
    this.updateLinkedElements()
  } // valueChanged

  updateLinkedElements() {
    if(this.selected && this.value) {
      if(this.calendar) {
        this.calendar.eventValueChanged = (el, value)=>{
          this.value = value
          this.nextUnit()
        }
        this.calendar.unit = this.selected
        this.calendar.value = this.value
      }
      if(this.snapshots) {
        this.snapshots.eventValueChanged = (el, value)=>{
          this.value = value
          this.nextUnit()
        }
        this.snapshots.unit = this.selected
        this.snapshots.value = this.value
      }
    }
  } // updateLinkedCalendar

  nextUnit() {
    let last_idx = UNITS.indexOf(this.lastunit)
    if(last_idx<0) last_idx = UNITS.length-1
    const idx = UNITS.indexOf(this.selected)
    if(idx<0 || idx>=last_idx) return
    this.selected = UNITS[idx+1]
  } // nextUnit
} // class meleCalendarDatetime

meleCalendarDatetime._properties = PROPERTIES
meleCalendarDatetime.observedAttributes = _.keys(PROPERTIES)
window.customElements.define('mele-calendar-datetime', meleCalendarDatetime)
